"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FONT_FAMILY = '"-apple-system", ' +
    '"BlinkMacSystemFont", ' +
    '"Segoe UI", ' +
    'Roboto, ' +
    '"Helvetica Neue", ' +
    'Helvetica, ' +
    '"PingFang SC", ' +
    '"Hiragino Sans GB", ' +
    '"Microsoft YaHei", ' +
    'SimSun, ' +
    '"sans-serif"';
//# sourceMappingURL=const.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/component/lib/const.js
// module id = 307
// module chunks = 37